import {
  CUSTOM_TILE_SECTION_SCHEMA,
  CUSTOM_TILE_SECTIONS_SCHEMA,
  DEFAULT_CUSTOM_TILE_SECTION,
  ICustomTileSection,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IListGateway, ISaveGateway } from '../gateways';

export class CustomTileSectionGateway
  implements
    IListGateway<null, IApiResponse<ICustomTileSection[]>>,
    ISaveGateway<ICustomTileSection[], IApiResponse<ICustomTileSection[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ICustomTileSection> =
    new RestCallBuilder<ICustomTileSection>(DEFAULT_CUSTOM_TILE_SECTION);

  private readonly listRestCallBuilder: RestCallBuilder<ICustomTileSection[]> =
    new RestCallBuilder<ICustomTileSection[]>([]);

  get(cardId: string | null): Observable<IApiResponse<ICustomTileSection>> {
    return this.restCallBuilder
      .get('/card' + cardId)
      .validate(
        API_RESPONSE_SCHEMA(CUSTOM_TILE_SECTION_SCHEMA),
        'ICustomTile.get'
      )
      .handleMessages()
      .build();
  }

  list(): Observable<IApiResponse<ICustomTileSection[]>> {
    return this.listRestCallBuilder
      .get('/custom-tile-sections/')
      .validate(
        API_RESPONSE_SCHEMA(CUSTOM_TILE_SECTIONS_SCHEMA),
        'ICustomTileSection.list'
      )
      .handleMessages()
      .build();
  }

  save(
    query: ICustomTileSection[]
  ): Observable<IApiResponse<ICustomTileSection[]>> {
    return this.listRestCallBuilder
      .post('/custom-tile-sections/', query)
      .validate(
        API_RESPONSE_SCHEMA(CUSTOM_TILE_SECTIONS_SCHEMA),
        'CustomTileSection.save'
      )
      .handleMessages()
      .build();
  }

  delete(
    sectionId: string | null
  ): Observable<IApiResponse<ICustomTileSection[]>> {
    return this.listRestCallBuilder
      .delete('/custom-tile-sections/' + sectionId)
      .handleMessages()
      .build();
  }
}
